import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import moment from "moment";
import { parseCheckInEvent } from "../utils/parseCheckInEvent";

export const getEventInfo = async ({ eventId, eventType }) => {
  const body = new FormData();
  const defaultValues = {
    AULAID: 0,
    CHATID: 0,
    LIVEID: 0,
    SESSAOID: 0,

    DATAHORA_LOCAL: moment().format("DD/MM/YYYY HH:mm:ss"),
  };
  switch (eventType.toUpperCase()) {
    case "AULA":
      body.append(
        "dados",
        JSON.stringify({ ...defaultValues, AULAID: eventId })
      );
      break;
    case "CHAT":
      body.append(
        "dados",
        JSON.stringify({ ...defaultValues, CHATID: eventId })
      );
      break;
    case "LIVE":
      body.append(
        "dados",
        JSON.stringify({ ...defaultValues, LIVEID: eventId })
      );
      break;
    case "SESSAO":
      body.append(
        "dados",
        JSON.stringify({ ...defaultValues, SESSAOID: eventId })
      );
      break;

    default:
      throw new Error("unknow event type");
  }
  const res = await axios.middleware.post(
    "https://middleware.cadernovirtual.com.br/Aluno.asmx/DadosSalaAcesso",
    body
  );

  return { ...res[0].data, ...parseCheckInEvent({ ...res[0].data }) };
};

export const useEventInfo = ({ config, eventId, eventType }) => {
  return useQuery({
    ...config,
    queryKey: ["eventInfo", { eventId, eventType }],
    queryFn: () => getEventInfo({ eventId, eventType }),
  });
};
